import React, {FC} from 'react';
import {MODERATOR_COURSE_LESSON_RESOURCE} from "../../../../../mock/URLs";
import {useDeleteModal} from "../../../../../context/DeleteModalContext";
import {LoaderSection} from "../../../../../components/sections/loader/Loader";
import {EmptySection} from "../../../../../components/sections/empty/Empty";
import imgBaseUrl from "../../../../../utils/imgBaseUrl";
import {KTIcon} from "../../../../../../_metronic/helpers";

type ResourceListProps = {
  resourceData: any;
  resourceIsLoading: boolean;
  refetchResources: () => void;
  handleEditClick: (resource: any) => void;
};

const ResourceList: FC<ResourceListProps> = ({resourceData, resourceIsLoading, refetchResources, handleEditClick}) => {
  const {openDeleteModal} = useDeleteModal();

  const handleDeleteClick = (id: number) => {
    openDeleteModal(MODERATOR_COURSE_LESSON_RESOURCE, id, refetchResources);
  };

  return (
    <div className="card mt-10">
      <div className="card-header">
        <div className="card-title">Darsga oid resurslar</div>
      </div>
      <div className="card-body">
        <table className="table table-row-bordered gy-7 gs-7">
          <thead>
            <tr className="fw-bolder fs-6 text-gray-800 border-bottom border-gray-200">
              <th>№</th>
              <th>Banner</th>
              <th>Darslik nomi</th>
              <th>Fayl</th>
              <th>Amallar</th>
            </tr>
          </thead>
          <tbody>
            {resourceIsLoading ? (
              <LoaderSection height="20vh"/>
            ) : resourceData?.data.length === 0 ? (
              <EmptySection height="20vh"/>
            ) : (
              resourceData?.data?.map((resource, index) => (
                <tr key={resource.id}>
                  <td>{index + 1}</td>
                  <td>
                    <img className="w-100px h-100px" src={imgBaseUrl(resource.banner!)} alt={resource?.title}/>
                  </td>
                  <td>
                    <p className="p-0 m-0">{resource.title}</p>
                    <p className="p-0 m-0">{resource.description}</p>
                  </td>
                  <td>
                    <a download className="btn btn-sm btn-primary" href={imgBaseUrl(resource.file!)} target="_blank" rel="noreferrer">
                      Faylni yuklab olish
                    </a>
                  </td>
                  <td className="d-flex gap-2">
                    <button className="btn btn-sm btn-light-primary" onClick={() => handleEditClick(resource)}>
                      <KTIcon iconName="pencil" iconType="duotone" className="fs-3"/>
                      Tahrirlash
                    </button>
                    <button onClick={() => handleDeleteClick(resource?.id)} className="btn btn-sm btn-icon btn-danger">
                      <KTIcon iconName="trash-square" iconType="duotone" className="fs-1"/>
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ResourceList;